import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ShareIcon from '@mui/icons-material/Share';
import { Button, CircularProgress } from "@mui/material";
import { ThemeProvider } from "@mui/styles";
import download from "downloadjs";
import { toBlob, toJpeg } from 'html-to-image';
import { QRCodeSVG } from 'qrcode.react';
import React, { Component } from "react";
import Barcode from 'react-barcode';
import { Link } from "react-router-dom";
import CircularLoading from "../components/CircularLoading";
import { GetRole, GuestLogin, Me, SetToken, SetUser, UpdateToken } from "../services/Session";
import { GetTicketByOrderID } from "../services/Ticket";
import "../styles/style.css";
import theme from "../styles/theme";

const BackIcon = "/assets/svg/back.svg";

class TransactionTicket extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order_id: '',
			data: {
				count: 0,
				results: [],
			},
			loading: false,
		}
	}

	componentDidMount = () => {
		this.handleGetTicket();
	}

	handleLogout = () => {
		GuestLogin().then(res => {
			Me(SetToken(res.data.token).access_token).then(res => {
				SetUser(res.data);
				setTimeout(this.props.history.push("/"), 3000);
			})
		})
	}

	handleGetTicket = () => {
		this.setState({ loading: true, order_id: this.props.match.params.id });
		GetTicketByOrderID(this.props.match.params.id)
		.then(res => {
			this.setState({ data: res.data });
			this.setState({ loading: false });
		})
		.catch(err => {
			this.setState({ loading: false });
			if (err.response) {
				if (err.response && err.response.status === 401) {
					this.setState({ attempt: this.state.attempt + 1 });
					if (this.state.attempt < 10) {
						UpdateToken().then(res => {
							Me(SetToken(res.data.token).access_token).then(res => {
								SetUser(res.data);
								setTimeout(this.handleGetTicket(), 5000);
							});
						});
					} else {
						this.handleLogout();
					}
				}
			}
		})
	}

	handleDownloadTicket = async (fileName) => {
		const dataUrl = await toJpeg(document.getElementById(fileName))
		download(dataUrl, 'tiket-'+fileName+'.jpeg')
	}

	handleShareTicket = async (fileName) => {
		if (navigator.share===undefined) {
			this.handleDownloadTicket(fileName)
		} else {
			const newFile = await toBlob(document.getElementById(fileName))
			try {
				await navigator.share({
					files: [
						new File([newFile], 'tiket-'+fileName+'.png', {
							type: newFile.type,
						}),
					],
					title: fileName,
					text: fileName,
				})
			} catch (err) {
				alert('Perangkat yang anda gunakan tidak mendukung, silakan menggunakan tombol unduh')
			}
		}
	}

	render() {
		const { order_id, data, loading } = this.state
		const backPath = '/transaksi/'+order_id
		const ticketStyle = { 
			background: '#ffffff',
			boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
			color: "#666", 
			display: "block", 
			fontSize: "12px", 
			height: "auto", 
			textAlign: "left", 
			width: 320,
		}
		return (
			<ThemeProvider theme={theme}>
				<div className="header">
					<Link to={backPath} style={{ position: "absolute", height: 60, width: 60, top: 0, left: 0 }}>
						<img alt="icon" src={BackIcon} />
					</Link>
					<div className="center">
						<h3 className="title">Daftar Tiket</h3>
					</div>
				</div>
				<div className="wrapper">
				{loading && (
					<div className="center" style={{ width: 40, height: 40 }}>
						<CircularLoading />
					</div>
				)}
				{data.count>0 && (
					<div className="highlights">
					{ 
						data.results.map((d) => (
						<div key={d.id} style={{ margin: 'auto' }}>
							<div id={d.number} style={ticketStyle}>
								<div style={{ textAlign: 'center', paddingTop: 20, fontSize: 16 }}>
									<b>{d.product ? d.product.name : ''}</b>
								</div>
								<hr/>
								<div style={{ textAlign: 'center', paddingTop: 20 }}>
									<QRCodeSVG
										value={d.number}
										size={128}
										bgColor={"#ffffff"}
										fgColor={"#000000"}
										level={"L"}
										includeMargin={false}
										imageSettings={{
											src: "/assets/images/logo-pernik-hsi.png",
											height: 30,
											width: 42,
											excavate: true,
										}}
									/>
								</div>
								<div style={{ padding: 10, fontSize: 14 }}>
									<div style={{marginBottom: '4px'}}>
										Nomor Tiket: 
										<span style={{ float: "right" }}>
											<b>{d.number}</b>
										</span>
									</div>
									<div style={{marginBottom: '4px'}}>
										Nama:
										<span style={{ float: "right" }}>
											<b>{d.owner ? d.owner.name : ''}</b>
										</span>
									</div>
									<div style={{marginBottom: '4px'}}>
										Jenis Kelamin:
										<span style={{ float: "right" }}>
											<b>{d.owner && d.owner.gender==='female' ? 'Perempuan' : 'Laki-laki'}</b>
										</span>
									</div>
									<div style={{marginBottom: '4px'}}>
										Nomor HP:
										<span style={{ float: "right" }}>
											{d.owner ? d.owner.phone : ''}
										</span>
									</div>
									<div style={{marginBottom: '4px'}}>
										Email:
										<span style={{ float: "right" }}>
											{d.owner ? d.owner.email : ''}
										</span>
									</div>
								</div>
								<div style={{ textAlign: 'center', paddingTop: 20 }}>
								<Barcode value={d.number} width={1.5} />
								</div>
							</div>
							<div style={ticketStyle}>
								<div style={{ textAlign: "center" }}>
									<Button
										variant='contained'
										color='primary'
										style={{ textTransform: 'none', margin: 10 }}
										startIcon={<CloudDownloadIcon/>}
										onClick={() => this.handleDownloadTicket(d.number)}>Unduh</Button>
									<Button
										variant='contained'
										color='primary'
										style={{ textTransform: 'none', margin: 10 }}
										startIcon={<ShareIcon/>}
										onClick={() => this.handleShareTicket(d.number)}>Bagikan</Button>
								</div>
							</div>
						</div>
					))
					}
					</div>
				)}
				</div>
			</ThemeProvider>
		);
	}
}

export default TransactionTicket;
